"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const hoc_1 = require("@apollo/client/react/hoc");
class WithMutation extends react_1.default.Component {
    getArguments() {
        const keys = Object.keys(this.props.params);
        if (keys.length === 0)
            return '';
        const args = keys
            .map(key => {
            const field = this.props.params[key];
            return `$${key}: ${field.__graphQLType}`;
        })
            .join(', ');
        return `(${args})`;
    }
    getParams() {
        const keys = Object.keys(this.props.params);
        if (keys.length === 0)
            return '';
        const params = keys
            .map(key => {
            return `${key}: $${key}`;
        })
            .join(', ');
        return `(${params})`;
    }
    getSubselection() {
        const fragment = this.props.fragment;
        if (!fragment)
            return '';
        const fragmentName = fragment.definitions[0].name.value;
        return `{...${fragmentName}}`;
    }
    getMutationText() {
        return `
      mutation ${this.props.mutation} ${this.getArguments()} {
        result: ${this.props.mutation}  ${this.getParams()} ${this.getSubselection()}
      }
    `;
    }
    getMutation() {
        const { client, fragment, refetchQueries = [] } = this.props;
        const text = this.getMutationText();
        const mutation = (0, graphql_tag_1.default)([text, ''], fragment || '');
        return async (variables) => {
            const { data } = await client.mutate({
                mutation,
                variables,
                refetchQueries
            });
            return data.result;
        };
    }
    render() {
        const mutate = this.getMutation();
        return this.props.children(mutate);
    }
}
exports.default = (0, hoc_1.withApollo)(WithMutation);
//# sourceMappingURL=index.js.map